module.exports = __webpack_public_path__ + "img/pic1.178f2dcf.png";